import { Select } from 'calc-controls';

const currencyOptions = [
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
  { value: 'CNY', label: 'CNY' },
  { value: 'JPY', label: 'JPY' },
];

interface CurrencySelectProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  style?: React.CSSProperties;
}

export function CurrencySelect({ label, value, onChange }: CurrencySelectProps) {
  const props: { options: typeof currencyOptions; value: string; onChange: (v: string) => void; label?: string } = {
    options: currencyOptions,
    value,
    onChange,
  };
  if (label !== undefined) props.label = label;
  return <Select {...props} />;
}
